import React from "react"
import Float from "../Float/Float"
import ThreeCirclesSVG from "../../../../images/backgroundBlur/three-circle.inline.svg"
import HorizontalOval_1 from "../../../../images/backgroundBlur/horizontal-oval.inline.svg"
import HorizontalOval_2 from "../../../../images/backgroundBlur/horizontal-oval2.inline.svg"
import HorizontalOval_3 from "../../../../images/backgroundBlur/horizontal-oval3.inline.svg"
import SmileSVG from "../../../../images/backgroundBlur/smile.inline.svg"
import SingleCircle from "../../../../images/backgroundBlur/circle-single.inline.svg"
import useDeviceType from "../../../../hooks/useDeviceType"
import Stain from "../../../../images/backgroundBlur/stain.inline.svg"

export type BlurBackgroundProps = {
  direction: "right" | "left" | "center"
  type:
    | "3circle"
    | "circle"
    | "oval"
    | "oval2"
    | "oval3"
    | "smile"
    | "stain1"
    | "stain2"
    | "stain3"
    | "stain4"
}

const BlurBackground = ({ direction, type }: BlurBackgroundProps) => {
  const DeviceType = useDeviceType()

  // Three Circles
  if (type === "3circle") {
    if (direction === "left")
      return (
        <Float top={-90} left={-300} backgroundImage removeResponsive>
          <ThreeCirclesSVG />
        </Float>
      )
    if (direction === "right")
      return (
        <Float top={0} right={-350} backgroundImage removeResponsive>
          <ThreeCirclesSVG />
        </Float>
      )
  } else if (type === "oval") {
    if (DeviceType !== "mobile" && DeviceType !== "tablet") {
      return (
        <Float right={-350} top={-150} backgroundImage>
          <HorizontalOval_1 />
        </Float>
      )
    } else {
      return (
        <Float
          right={-350}
          bottom={150}
          backgroundImage
          style={{ transform: "rotate(50deg)" }}
        >
          <HorizontalOval_1 />
        </Float>
      )
    }
  } else if (type === "oval2") {
    if (DeviceType !== "mobile" && DeviceType !== "tablet") {
      return (
        <Float right={-500} top={-180} backgroundImage>
          <HorizontalOval_2 />
        </Float>
      )
    } else {
      return (
        <Float right={-500} top={-150} rotate={45} backgroundImage>
          <HorizontalOval_2 />
        </Float>
      )
    }
  } else if (type === "oval3") {
    return (
      <Float right={-400} top={-200} backgroundImage>
        <HorizontalOval_3 />
      </Float>
    )
  } else if (type === "smile")
    return (
      <Float
        left="-29%"
        right="-29%"
        top={-180}
        backgroundImage
        removeResponsive
      >
        <SmileSVG />
      </Float>
    )
  else if (type === "circle") {
    if (direction === "left") {
      return (
        <Float left={-350} top={-150} backgroundImage>
          <SingleCircle />
        </Float>
      )
    }
    if (direction === "right") {
      return (
        <Float right={-350} top={-150} backgroundImage>
          <SingleCircle />
        </Float>
      )
    }
  } else if (type === "stain1") {
    if (DeviceType !== "mobile") {
      return (
        <Float right={-300} top={-300} backgroundImage>
          <Stain />
        </Float>
      )
    } else {
      return (
        <Float right={-600} top={-280} backgroundImage>
          <Stain />
        </Float>
      )
    }
  } else if (type === "stain2") {
    if (DeviceType !== "mobile" && DeviceType !== "tablet") {
      return (
        <Float left={-550} top={-230} backgroundImage>
          <Stain />
        </Float>
      )
    } else {
      return (
        <Float
          left={-390}
          top={-360}
          backgroundImage
          style={{ transform: "scale(0.5)", opacity: 0.5 }}
        >
          <Stain />
        </Float>
      )
    }
  } else if (type === "stain3") {
    if (DeviceType !== "mobile" && DeviceType !== "tablet") {
      return (
        <Float
          right={-350}
          top={-200}
          backgroundImage
          style={{ transform: "rotate(180deg)" }}
        >
          <Stain />
        </Float>
      )
    } else {
      return (
        <Float
          right={-420}
          bottom={-220}
          backgroundImage
          style={{ transform: "rotate(180deg)" }}
        >
          <Stain />
        </Float>
      )
    }
  } else if (type === "stain4") {
    if (DeviceType !== "mobile" && DeviceType !== "tablet") {
      return (
        <Float
          left={-570}
          top={-200}
          backgroundImage
          style={{ transform: "rotate(180deg)" }}
        >
          <Stain />
        </Float>
      )
    }
  }

  return
}

export default BlurBackground
